module.exports = __webpack_public_path__ + "static/media/pay-service.57048c21.png";